import { RouteObject } from 'react-router-dom';
import AdminPage from '../pages/AdminPage';
import NewDataAssetImportPage from './pages/NewDataAssetImportPage';
import NewDataWorkOrderImportPage from './pages/NewDataWorkOrderImportPage';
import NewDataFindingsImportPage from './pages/NewDataFindingsImportPage';
import NewDataCapitalNeedImportPage from './pages/NewDataCapitalNeedImportPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage tab="data-import" />,
  },
  {
    path: 'assets',
    element: <NewDataAssetImportPage />,
  },
  {
    path: 'work-orders',
    element: <NewDataWorkOrderImportPage />,
  },
  {
    path: 'findings',
    element: <NewDataFindingsImportPage />,
  },
  {
    path: 'capital-needs',
    element: <NewDataCapitalNeedImportPage />,
  },
];

export default routes;
